export default class GlobalNav {
    constructor(elem, APP) {
        this.elem = elem

        this.searchBtn = this.elem.querySelector('.search-button')
        this.searchForm = this.elem.querySelector('.search-form')
        this.navTrigger = this.elem.querySelector('.menu-toggle')
        this.logo = document.body.querySelector('.custom-logo')
        this.mainNavigation = this.elem.querySelector('.main-navigation')

    }
    searchToggle() {
        this.searchBtn.addEventListener('click', () => {
            this.searchBtn.classList.add('active')
            this.searchBtn.classList.toggle('is-hidden')
            this.searchForm.classList.toggle('active')
            this.logo.classList.add('is-hidden-mobile')
        })
    }

    toggleIconColor() {
        this.navTrigger.addEventListener('click', () => {
            this.logo.classList.toggle('invert')
            this.searchBtn.classList.toggle('invert')

            if(this.searchForm.classList.contains('active')) {
                this.searchForm.classList.remove('active')
                this.searchBtn.classList.remove('is-hidden')
                this.searchBtn.classList.remove('active')
                this.logo.classList.remove('is-hidden-mobile')
            } else {
                this.logo.classList.remove('is-hidden-mobile')
            }
            // if(this.mainNavigation.classList.contains('toggled')) {
            //     this.searchForm.classList.remove('active')
            // }
        })
    }


    init() {
        this.searchToggle()
        this.toggleIconColor()
    }
}